export function validateEmail (value: string) {
    return value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
}

export function validateName (value: string, limit=250) {
    if (!value) {
        return true;
    }
    if (value.length > limit) {
        return false;
    }
    return validateText(value);
    // return !value.match(/[!@#$%^&*();?":{}|<>]/i);
}

export function validateText (value: string, limit=1000) {
    if (!value) {
        return true;
    }
    if (value.length > limit) {
        return false;
    }
    return !value.match(/[;"\\]/i) && !value.match(/(\r\n|\r|\n)/i);
    // return !value.match(/[!^*;":{}|<>]/i);
}

export function validatePhoneNumberExtended (value: string) {
    return value.match(/^([0-9]( |-)?)?(\(?[0-9]{3}\)?|[0-9]{3})( |-)?([0-9]{3}( |-)?[0-9]{4}|[a-zA-Z0-9]{7})$/i);
}

export function validatePhoneNumber (value: string) {
    return value.match(/^([2-9]{1}[0-9]{9})|([2-9]{1}[0-9]{2}(-)[0-9]{3}(-)[0-9]{4})$/i)
}
